import React from 'react'
import { Trans } from 'react-i18next'
import { Cohort } from 'constants/rootConstants'
import { useComplianceVersion } from 'hooks/useComplianceVersion'
import { useZustandStore } from 'zustandGlobalStore'
import { StyledFirstPageLegalNotice as S } from './FirstPageLegalNotice.styles'

export const FirstPageLegalNotice: React.FC<{ inline?: boolean }> = ({
  inline,
}) => {
  const cohort = useZustandStore((state) => state.lead?.cohort)
  const complianceVersion = useComplianceVersion()
  const isIntl2Compliance =
    (cohort === Cohort.INTL_2 ||
      cohort === Cohort.INTL_2LW ||
      cohort === Cohort.INTL_D60 ||
      cohort === Cohort.INTL_D70) &&
    complianceVersion !== null

  return (
    <S.Wrapper $inline={inline}>
      <Trans
        i18nKey={
          isIntl2Compliance
            ? 'firstPageLegalNotice.ourVariant'
            : 'firstPageLegalNotice.theVariant'
        }
        components={[
          <S.Link
            href="/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
          />,
          <S.Link
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          />,
        ]}
      />
    </S.Wrapper>
  )
}
